import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.brandfolder(); // bulk management passed as collection due to routing
const url = () => `/api/v4/${type.toLowerCase()}s/${key}/rules?per=1000`;

export const get = () => (
  fetchJSON(url())
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);

export const create = (options) => (
  fetchJSON(url(), {
    method: 'POST',
    body: {
      data: {
        attributes: {
          ...options
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); })
);
